var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocation = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65199 1C3.98261 1 1 3.83859 1 7.32699C1 12.8066 7.08901 19.582 7.34853 19.867C7.42439 19.9506 7.53221 20 7.65199 20C7.76777 20 7.87558 19.9506 7.95145 19.867C8.21099 19.582 14.3 12.8066 14.3 7.32699C14.3 3.83859 11.3174 1 7.65199 1ZM7.65199 10.4848C5.82328 10.4848 4.33397 9.06739 4.33397 7.32699C4.33397 5.5866 5.82328 4.17299 7.65199 4.17299C9.4767 4.17299 10.966 5.5866 10.966 7.32699C10.966 9.06739 9.4767 10.4848 7.65199 10.4848Z",
    stroke: "#FA6400",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Location.9460c85a.svg";
export { ForwardRef as ReactComponent };